import { withCdnUrl } from "@smile2impress/attraction-utils";
import { PictureProps } from "@smile2impress/components/relaunch";

const pageContent = (): PictureProps[] => {
    return new Array(6).fill(null).map((_, index: number) => ({
        images: [
            {
                png: withCdnUrl(
                    `/images/relaunch/awards/award-logo-${index + 1}_mobile.png`
                ),
            },
            {
                png: withCdnUrl(
                    `/images/relaunch/awards/award-logo-${
                        index + 1
                    }_desktop.png`
                ),
            },
        ],
        defaultSrc: withCdnUrl(
            `/images/relaunch/awards/award-logo-${index + 1}_mobile.png`
        ),
    }));
};

export default pageContent;
